import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Project, ProjectControllerService} from "../api";
import {StateConfigService} from "../services/state/state-config.service";
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProjectResolver  {
  private stateConfigService = inject(StateConfigService);
  private projectControllerService = inject(ProjectControllerService);


  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Project> {
    let id = Number(route.paramMap.get('id'));
    if (isNaN(id)) {
      id = this.stateConfigService.getProjectId();
    }

    // If the correct project is already in memory, return it immediately to avoid
    // blocking navigation and showing the global loading spinner unnecessarily.
    // The dashboard's own skeleton loaders handle the per-tile data loading state.
    if (this.stateConfigService.selectedProject?.id === id) {
      this.stateConfigService.selectOrganisationForProject(this.stateConfigService.selectedProject);
      return of(this.stateConfigService.selectedProject);
    }

    return this.projectControllerService.getProject(id).pipe(
      tap(project => {
        this.stateConfigService.selectedProject = project;
        this.stateConfigService.selectOrganisationForProject(project);
      })
    );

  }
}
